import React from 'react';
import ReactDOM from 'react-dom';

import core from '~/core/scripts';
import Map from '~/core/scripts/components/Map';

import './styles/main.styl';

core.init();

const mapContainer = document.getElementById('map');

if (mapContainer) {
  ReactDOM.render(<Map />, mapContainer);
}
